// import { FetchContext } from 'context/FetchContext';
// import { useContext } from 'react';
// import { useMutation, useQueryClient } from 'react-query';

// function useManageMindMap(data = {}) {
//   const { courseID, chapterID, ...rest } = data;
//   const fetchContext = useContext(FetchContext);
//   const { privateFetch } = fetchContext;
//   const queryClient = useQueryClient();

//   function addPlan(apiData) {
//     return privateFetch.post(`/v1/admin/course/${courseID}/chapter/${chapterID}`, apiData);
//   }

//   // function updatePlan({ id: planID, ...rest } = {}) {
//   //   return privateFetch.put(`/v1/admin/plan/${planID}`, rest);
//   // }

//   function manageData(payload) {
//     // if (payload.id) return updatePlan(payload);

//     return addPlan(payload);
//   }

//   return useMutation(manageData, {
//     onSuccess() {},
//     onError() {},
//     onSettled() {
//       queryClient.invalidateQueries('chapter-mindmap');
//     },
//   });
// }

// export default useManageMindMap;

import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { FetchContext } from 'context/FetchContext';

function useManageMindMap({ courseId, chapterId }) {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  const addMindMap = (data = {}) =>
    privateFetch.post(`/v1/admin/course/${courseId}/chapter/${chapterId}/mind-map`, data);

  const deleteMindMap = () =>
    privateFetch.delete(`/v1/admin/course/${courseId}/chapter/${chapterId}/mind-map`);

  const manageMindMap = (payload = {}) => {
    if (payload.type === 'DELETE') {
      return deleteMindMap();
    }
    const { type, ...data } = payload;
    return addMindMap(data);
  };

  return useMutation(manageMindMap, {
    onSettled: () => queryClient.invalidateQueries(['chapter-mindmap', chapterId]),
  });
}

export default useManageMindMap;
